<template>
  <div class="bodys" style="padding-bottom: 20px">
    <!-- 顶部部分 -->
    <dv-border-box-11 :title="title" :titleWidth="290" >
      <div class="topStyle">
        <div>&nbsp;</div>
      </div>
      <!-- 主体部分 -->
      <div class="mainStyle">
        <!-- 左边数据表格 -->
        <div>
          <dv-border-box-10>
            <div>行业投资占比</div>
            <div id="container01"></div>
          </dv-border-box-10>
          <dv-border-box-10>
            <div>投资变化趋势(按行业)</div>
            <div id="container02"></div>
          </dv-border-box-10>
          <!--                    <dv-border-box-10>-->
          <!--                        <div>投资变化趋势(按行业)</div>-->
          <!--                        <div id="container03"></div>-->
          <!--                    </dv-border-box-10>-->
        </div>
        <!-- 中间部分 -->
        <div>
          <!-- 地图 -->
          <div>
            <div id="containerMap" style="width: 100%; height: 100%"></div>
          </div>
          <!-- 三维跑车模型 -->
          <div>
            <div id="modelCar"></div>
          </div>
        </div>
        <!-- 右边数据表格 -->
        <div>
          <dv-border-box-10>
            <div>涉及行业及所在国家(地区)</div>
            <div id="container04"></div>
          </dv-border-box-10>
          <dv-border-box-10>
            <div>各行业投资方式分析</div>
            <div id="container05"></div>
          </dv-border-box-10>
        </div>
      </div>
    </dv-border-box-11>
  </div>
</template>

<script>
import * as g2plot from '@antv/g2plot';
import * as echarts from 'echarts';
export default {
  name: 'YRD',
  data() {
    return {
      // 页面标题
      title: ' 长三角走出去综合服务平台 ',
    };
  },
  mounted() {
    // 地图加载
    this.loadMap();
    // 数据表格加载
    setTimeout(() => {
      this.loadContainer01();
      this.loadContainer02();
      // this.loadContainer03();
      this.loadContainer04();
      this.loadContainer05();
      // this.loadContainer06();
    }, 500);
  },
  methods: {
    loadMap() {
      fetch('https://www.chinamerger.com/chinamergerImage/activity/20231123/js/world-asia-center.json')
        .then((response) => response.json())
        .then((list) => {
          echarts.registerMap('world', list);
          var regions = [{"name":"China","itemStyle":{"normal":{"areaColor":"red"}}},{"name":"Somalia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Liechtenstein","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Morocco","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"W. Sahara","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Serbia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Afghanistan","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Angola","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Albania","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Aland","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Andorra","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"United Arab Emirates","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Argentina","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Armenia","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"American Samoa","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Fr. S. Antarctic Lands","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Antigua and Barb.","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Australia","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Austria","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Azerbaijan","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Burundi","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Belgium","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Benin","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Burkina Faso","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Bangladesh","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Bulgaria","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Bahrain","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Bahamas","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Bosnia and Herz.","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Belarus","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Belize","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Bermuda","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Bolivia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Brazil","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Barbados","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Brunei","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Bhutan","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Botswana","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Central African Rep.","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Canada","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Switzerland","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Chile","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Côte d'Ivoire","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Cameroon","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Dem. Rep. Congo","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Congo","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Colombia","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Comoros","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Cape Verde","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Costa Rica","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Cuba","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Curaçao","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Cayman Is.","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"N. Cyprus","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Cyprus","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Czech Rep.","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Germany","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Djibouti","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Dominica","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Denmark","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Dominican Rep.","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Algeria","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Ecuador","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Egypt","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Eritrea","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Spain","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Estonia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Ethiopia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Finland","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Fiji","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Falkland Is.","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"France","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Faeroe Is.","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Micronesia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Gabon","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"United Kingdom","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Georgia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Ghana","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Guinea","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Gambia","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Guinea-Bissau","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Eq. Guinea","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Greece","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Grenada","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Greenland","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Guatemala","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Guam","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Guyana","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Heard I. and McDonald Is.","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Honduras","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Croatia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Haiti","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Hungary","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Indonesia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Isle of Man","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"India","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Br. Indian Ocean Ter.","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Ireland","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Iran","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Iraq","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Iceland","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Israel","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Italy","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Jamaica","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Jersey","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Jordan","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Japan","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Siachen Glacier","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Kazakhstan","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Kenya","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Kyrgyzstan","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Cambodia","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Kiribati","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Korea","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Kuwait","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Lao PDR","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Lebanon","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Liberia","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Libya","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Saint Lucia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Sri Lanka","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Lesotho","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Lithuania","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Luxembourg","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Latvia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Moldova","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Madagascar","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Mexico","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Macedonia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Mali","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Malta","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Myanmar","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Montenegro","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Mongolia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"N. Mariana Is.","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Mozambique","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Mauritania","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Montserrat","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Mauritius","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Malawi","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Malaysia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Namibia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"New Caledonia","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Niger","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Nigeria","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Nicaragua","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Niue","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Netherlands","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Norway","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Nepal","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"New Zealand","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Oman","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Pakistan","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Panama","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Peru","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Philippines","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Palau","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Papua New Guinea","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Poland","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Puerto Rico","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Dem. Rep. Korea","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Portugal","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Paraguay","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Palestine","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Fr. Polynesia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Qatar","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Romania","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Russia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Rwanda","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Saudi Arabia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Sudan","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"S. Sudan","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Senegal","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Singapore","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"S. Geo. and S. Sandw. Is.","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Saint Helena","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Solomon Is.","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Sierra Leone","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"El Salvador","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"St. Pierre and Miquelon","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"São Tomé and Principe","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Suriname","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Slovakia","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Slovenia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Sweden","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Swaziland","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Seychelles","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Syria","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Turks and Caicos Is.","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Chad","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Togo","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Thailand","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Tajikistan","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Turkmenistan","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Timor-Leste","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Tonga","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Trinidad and Tobago","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Tunisia","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Turkey","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Tanzania","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Uganda","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Ukraine","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Uruguay","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"United States","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Uzbekistan","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"St. Vin. and Gren.","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"Venezuela","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"U.S. Virgin Is.","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"Vietnam","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Vanuatu","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Samoa","itemStyle":{"normal":{"areaColor":"#029AF2"}}},{"name":"Yemen","itemStyle":{"normal":{"areaColor":"#A2D2E2"}}},{"name":"South Africa","itemStyle":{"normal":{"areaColor":"#D1DCF0"}}},{"name":"Zambia","itemStyle":{"normal":{"areaColor":"#00A2EF"}}},{"name":"Zimbabwe","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"","itemStyle":{"normal":{"areaColor":"#71C1F1"}}},{"name":"","itemStyle":{"normal":{"areaColor":"#029AF2"}}}];
          console.log(document.getElementById('chart4'))
          var myChart = echarts.init(document.getElementById('containerMap'));
          var s_data = [];
          const translationLng = ([lng, lat]) => {
            if (lng > -30) {
              lng = lng - 180;
            } else {
              lng = lng + 180;
            }
            return [lng, lat];
          };

          function addLine(start, end) {
            s_data.push({
              type: 'lines',
              zlevel: 2,
              effect: {
                show: false,
                period: 5,
                // constantSpeed: 200,
                delay: 0,
                trailLength: 0.5,
                color: '#ffffff',
                symbol: 'pin',
                symbolSize: 10,
              },
              symbol: ['pin','circle'],
              symbolSize: 10,
              lineStyle: {
                normal: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [{
                      offset: 0, color: 'red' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#ffeb40' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                  },
                  cap: 'round',
                  width: 1,
                  opacity: 0.8,
                  curveness: end[0] < 0 || end[0] > start[0] ? 0.2 : -0.2,
                  shadowBlur: 1,
                  shadowColor: '#ffeb40'
                }
              },
              data: [{coords: [translationLng(start), translationLng(end)]}]
            })
          }

          addLine([115.429062, 40.044332, 500], [114.15, 22.15, 107])
          addLine([115.429062, 40.044332, 500], [101.15, 15.15, 107])//泰国
          addLine([115.429062, 40.044332, 500], [110.15, -7.15, 107])//印尼
          addLine([115.429062, 40.044332, 500], [-100.15, 40.15, 107])//美国
          addLine([115.429062, 40.044332, 500], [103.5, 1, 107])//新加坡
          addLine([115.429062, 40.044332, 500], [4, 46, 107])//法国
          addLine([115.429062, 40.044332, 500], [109, 13, 107])//越南
          addLine([115.429062, 40.044332, 500], [-81, 19, 107])//开曼群岛
          addLine([115.429062, 40.044332, 500], [27, 65, 107])//芬兰
          addLine([115.429062, 40.044332, 500], [-78, -1, 107])//厄瓜多尔
          addLine([115.429062, 40.044332, 500], [140, -25, 107])//澳大利亚
          addLine([115.429062, 40.044332, 500], [140, 38, 107])//日本
          addLine([115.429062, 40.044332, 500], [-102, 21, 107])//墨西哥
          s_data.push({
            name: '散点',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: [
              // {name: '中国', value: [-65.429062, 40.044332, 500, 1, '1亿']},
              {name: '香港', value: [-55.159062, 20.144332, 21, 1, '2.1亿']},
              {name: '泰国', value: [-88.159062, 10.144332, 16, 2, '1.6亿']},
              {name: '印度尼西亚', value: [-60.159062, -12.144332, 12, 3, '1.2亿']},
              {name: '美国', value: [90.429062, 37.044332, 12, 4, '1.2亿']},
              {name: '新加坡', value: [-84.5, -6, 10, 5, '1亿']},
              {name: '法国', value: [-182, 40, 4, 6, '0.4亿']},
              {name: '越南', value: [-63, 7, 3, 7, '0.3亿']},
              {name: '开曼群岛', value: [109, 14, 2, 8, '0.2亿']},
              {name: '芬兰', value: [-161.5, 59, 1, 9, '0.1亿']},
              {name: '厄瓜多尔', value: [111, -6, 1, 12, '0.1亿']},
              {name: '澳大利亚', value: [-32, -32, 1, 13, '0.1亿']},
              {name: '日本', value: [-33, 31, 1, 11, '0.1亿']},
              {name: '墨西哥', value: [70, 16, 1, 11, '0.1亿']},
            ],
            symbolSize: function (val) {
              return val[2] / 10;
            },
            label: {
              normal: {
                formatter: (v) => {
                  console.log(v)
                  return "{a|" + v.value[3] + "}\n{b|" + v.value[4] + "\n" + v.name + "}"
                },
                color:'#fff',
                rich:{
                  a:{
                    color:'#d3aa23',
                    lineHeight: 20,
                    fontWeight:'800',
                  },
                  b:{
                    lineHeight: 20,
                    fontWeight:'800',
                  }
                },
                align: 'center',
                verticalAlign: 'middle',
                position: 'inside',
                padding: 10,
                show: true,
                backgroundColor: 'rgba(0,0,0,0.8)',
                borderRadius: 100,
                borderWidth: 3,
                borderColor: 'rgb(32,130,206)',
                width: 60,
                height: 60,
                offset:[0,0]
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: 'rgba(255,255,255,0.8)'
              }
            }
          })
          var option = {
            tooltip: {
              trigger: 'item',
            },
            geo: {
              map: 'world',
              label: {
                show: false,
                position: 'insideLeft',
                color: 'white',
                fontSize: '10',
                emphasis: {
                  show: true
                }
              },
              regions: regions,
              roam: true,
              silent: true,
              itemStyle: {
                normal: {
                  // areaColor: ["#D1DCF0", "#A2D2E2", "#71C1F1", "#00A2EF", "#029AF2"],
                  areaColor: 'transparent',
                  borderColor: '#0e88eb',
                  // shadowBlur: 10,
                  // shadowColor: '#0e94ea'
                },
              },
              left: 10,
              right: 10,
              scaleLimit:{
                min:1,
                max:1
              }
            },
            series: s_data
          };
          myChart.setOption(option);
        });
    },
    loadContainer06() {
      fetch('https://gw.alipayobjects.com/os/bmw-prod/b21e7336-0b3e-486c-9070-612ede49284e.json')
        .then((res) => res.json())
        .then((data) => {
          const area = new g2plot.Area('container06', {
            data,
            xField: 'date',
            yField: 'value',
            seriesField: 'country',
            slider: {
              start: 0.1,
              end: 0.9,
              textStyle: {
                fill: '#fff'
              }
            },
            xAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            yAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            legend: {
              itemName: {
                style: {
                  fill: '#fff'
                }
              }
            }
          });
          area.render();
        });
    },
    loadContainer05() {
      const data = [
        { type: '新制造', value: 27 },
        { type: '新医疗', value: 25 },
        { type: '新一代信息技术', value: 18 },
        { type: '新能源新材料', value: 15 },
        { type: '新消费新文娱', value: 10 },
      ];

      const piePlot = new g2plot.Pie('container05', {
        appendPadding: 10,
        data,
        legend: {
          itemName: {
            style: {
              fill: '#fff'
            }
          }
        },
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
          type: 'inner',
          offset: '-30%',
          content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
          style: {
            fontSize: 14,
            textAlign: 'center'
          }
        },
        interactions: [{ type: 'element-active' }, { type: 'element-selected' }]
      });

      piePlot.render();
      // 如果业务中还有单选联动，可以考虑使用按住某个键来区分交互 (或者多选之后，让用户自己去触发查询)
      document.addEventListener('keyup', (evt) => {
        if (evt.key === 'Shift') {
          console.info(evt);
          const states = piePlot.getStates();
          console.info(states.filter((d) => d.state === 'selected'));
          // 获取选中元素
          // states.filter(d => d.state === 'selected')
        }
      });
    },
    loadContainer04() {
      fetch('https://gw.alipayobjects.com/os/antfincdn/mor%26R5yBI9/stack-group-column.json')
        .then((data) => data.json())
        .then((data) => {

          const k = {
            '办公用品': '新制造',
            '家电家具': '新医疗',
            '电子产品': '新一代信息技术',
          };
          const res = []
          for (let dataKey in data) {
            const temp = data[dataKey]
            res.push({
              product_type: k[temp.product_type],
              order_amt: temp.order_amt,
            })
          }
          const column = new g2plot.Column('container04', {
            data:res,
            xField: 'product_type',
            yField: 'order_amt',
            isGroup: true,
            // isStack: true,
            // seriesField: 'product_sub_type',
            // groupField: 'sex',
            xAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            yAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            legend: {
              itemName: {
                style: {
                  fill: '#fff'
                }
              }
            }
          });

          column.render();
        });
    },
    loadContainer03() {
      fetch('https://gw.alipayobjects.com/os/antvdemo/assets/data/antv-keywords.json')
        .then((res) => res.json())
        .then((data) => {
          const wordCloud = new g2plot.WordCloud('container03', {
            data,
            wordField: 'name',
            weightField: 'value',
            colorField: 'name',
            wordStyle: {
              fontFamily: 'Verdana',
              fontSize: [8, 32],
              rotation: 0
            },
            random: () => 0.5
          });

          wordCloud.render();
        });
    },
    loadContainer02() {
      const averageData = [
        { date: '2015-02', value: 21168 },
        { date: '2015-08', value: 21781 },
        { date: '2016-01', value: 23818 },
        { date: '2017-02', value: 25316 },
        { date: '2018-01', value: 26698 },
        { date: '2018-08', value: 27890 }
      ];

      const plot = new g2plot.Mix('container02', {
        appendPadding: 8,
        tooltip: { shared: true },
        syncViewPadding: true,
        plots: [
          {
            type: 'column',
            options: {
              data: [
                { date: '2015-02', value: 160 },
                { date: '2015-08', value: 245 },
                { date: '2016-01', value: 487 },
                { date: '2017-02', value: 500 },
                { date: '2018-01', value: 503 },
                { date: '2018-08', value: 514 }
              ],
              xField: 'date',
              yField: 'value',
              yAxis: {
                type: 'log',
                max: 100000,
                label: {
                  style: {
                    fill: '#fff'
                  }
                }
              },
              meta: {
                date: {
                  sync: true
                },
                value: {
                  alias: '店数(间)'
                }
              },
              label: {
                position: 'middle',
                style: {
                  fill: '#fff'
                }
              }
            }
          },
          {
            type: 'line',
            options: {
              data: averageData,
              xField: 'date',
              yField: 'value',
              xAxis: false,
              yAxis: {
                type: 'log',
                max: 100000,
                label: {
                  style: {
                    fill: '#fff'
                  }
                }
              },
              label: {
                offsetY: -8,
                style: {
                  fill: '#fff'
                }
              },
              meta: {
                value: {
                  alias: '平均租金(元)'
                }
              },
              color: '#FF6B3B',
              annotations: averageData.map((d) => {
                return {
                  type: 'dataMarker',
                  position: d,
                  point: {
                    style: {
                      stroke: '#FF6B3B',
                      lineWidth: 1.5
                    }
                  }
                };
              })
            }
          },
          {
            type: 'line',
            options: {
              data: [
                { date: '2015-02', value: null },
                { date: '2015-08', value: 0.029 },
                { date: '2016-01', value: 0.094 },
                { date: '2017-02', value: 0.148 },
                { date: '2018-01', value: 0.055 },
                { date: '2018-08', value: 0.045 }
              ],
              xField: 'date',
              yField: 'value',
              xAxis: {
                label: {
                  style: {
                    fill: '#fff'
                  }
                }
              },
              yAxis: {
                line: null,
                grid: null,
                position: 'right',
                max: 0.16,
                tickCount: 8,
                label: {
                  style: {
                    fill: '#fff'
                  }
                }
              },
              meta: {
                date: {
                  sync: 'date'
                },
                value: {
                  alias: '递增',
                  formatter: (v) => `${(v * 100).toFixed(1)}%`
                }
              },
              smooth: true,
              label: {
                callback: (value) => {
                  return {
                    offsetY: value === 0.148 ? 36 : value === 0.055 ? 0 : 20,
                    style: {
                      fill: '#1AAF8B',
                      fontWeight: 700,
                      stroke: '#fff',
                      lineWidth: 1
                    }
                  };
                }
              },
              color: '#1AAF8B'
            }
          }
        ]
      });

      plot.render();
    },
    loadContainer01() {
      fetch('https://gw.alipayobjects.com/os/antfincdn/PC3daFYjNw/column-data.json')
        .then((data) => data.json())
        .then((data) => {

          const k = {
            '茶叶': '新制造',
            '特产零食': '新医疗',
            '米面': '新一代信息技术',
            '水果': '新能源新材料'
          };
          const res = []
          for (let dataKey in data) {
            const temp = data[dataKey]
            res.push({
              city: temp.city,
              value: temp.value,
              type: k[temp.type],
            })
          }
          const column = new g2plot.Column('container01', {
            data: res,
            xField: 'city',
            yField: 'value',
            seriesField: 'type',
            isGroup: 'true',
            columnStyle: {
              radius: [20, 20, 0, 0]
            },
            xAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            yAxis: {
              label: {
                style: {
                  fill: '#fff'
                }
              }
            },
            legend: {
              itemName: {
                style: {
                  fill: '#fff'
                }
              }
            }
          });

          column.render();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.mainStyle {
  color: #ffffff;
  margin: 2% 5%;
  height: 85%;
  display: flex;
  > div:nth-child(1),
  div:nth-child(3) {
    width: 25%;
    > div {
      width: 100%;
      height: 50%;
      margin: 4% 0;
      > div {
        > div {
          display: flex;
          justify-content: center;
          width: 94%;
          margin: 0 3%;
        }
        > div:nth-child(1) {
          padding-top: 2%;
          font-size: 20px;
          font-family: 'FZY4JW';
          color: #35f3fd;
        }
        > div:nth-child(2) {
          height: 79%;
        }
      }
    }
  }
  > div:nth-child(2) {
    width: 50%;
    > div {
      padding: 0 2%;
    }
    > div:nth-child(1) {
      margin-top: 1%;
      height: 100%;
      > div > div {
        position: absolute;
        top: 2.5%;
        height: 95% !important;
      }
    }
    > div:nth-child(2) {
      margin-top: 1%;
      height: 35%;
      > div {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.topStyle {
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.6% 6% 0 6%;
  font-size: 18px;
  > div:nth-child(2) {
    font-size: 32px;
    font-family: 'FZZiYHJW';
    letter-spacing: 3px;
    margin-left: 4%;
  }
}

.bodys {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-image: url('@/assets/background.png');
  background-size: 100% 100%;
}

@font-face {
  font-family: 'FZZiYHJW';
  src: url('@/assets/font/FZZiYHJW.TTF');
}

@font-face {
  font-family: 'FZY4JW';
  src: url('@/assets/font/FZY4JW.TTF');
}
</style>
